<div class="settings-container">
  <cc-panel-with-links [displayTabsPanel]="true">
    <div tabsPanel>
      <span class="tab-title">
        <img
          src="assets/icons/multi-colored-icons/dashpivot-square.svg"
          alt="dashpivot-logo"
          class="sm-mr-1"
        />
        <h3 i18n>Workspace Settings</h3>
      </span>
      <cc-panel-with-links-tabs class="sm-mb-4" [panelTabs]="workspaceSettingTabs"></cc-panel-with-links-tabs>
    </div>

    <div tabsPanel>
      <span class="tab-title">
        <img
          src="assets/icons/multi-colored-icons/sitemate-start-square.svg"
          alt="sitemate-start-logo"
          class="sm-mr-1"
        />
        <h3 i18n>Sitemate Start</h3>
      </span>
      <cc-panel-with-links-tabs
        class="sm-mb-4"
        [panelTabs]="sitemateStartSettingTabs"
      ></cc-panel-with-links-tabs>
    </div>
  </cc-panel-with-links>
</div>
